import { api } from "../config";

export const apiCallsPreventiveMaintenance = {
    Actions: {
        GetStatsDemo: async (filters) => {
            try {
                const fromDateTime = filters.fromDate.hour(filters.fromTime.hour()).minute(filters.fromTime.minute()).second(filters.fromTime.second() || 0);
                const toDateTime = filters.toDate.hour(filters.toTime.hour()).minute(filters.toTime.minute()).second(filters.toTime.second() || 0);
                const fromDateFormat = fromDateTime.toISOString();
                const toDateFormat = toDateTime.toISOString();
                const response = await api.get("Maintenance/statisticsForGraph", {
                    NsApplication: "megara",
                    startDate: fromDateFormat,
                    endDate: toDateFormat,
                });

                return response.data;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
            }
        },

        GetDataTable: async () => {
            try {
                const response = await api.get("Maintenance", {    
                    NsApplication: "megara",
                    page: 1,
                    pageSize: 1,
                    export: false,
                });
        
                return response.data;
            } catch (error) {
                console.error("API Error", error.response?.data || error.message);
            }
        },        

        NewFlowMaintenance: async (maintenance) => {
            try {
                const response = await api.post("Maintenance", {
                    NsApplication : "megara",
                    submissionDate: maintenance.submissionDate,
                    maintenanceType: maintenance.mainteanceType,
                    registrationdate : maintenance.registrationdate, 
                    registrationtime : maintenance.registrationtime, 
                    typemaintenance : maintenance.typemaintenance, 
                    deviceType : maintenance.devicetype, 
                    deviceflowid : maintenance.deviceflowid, 
                    county : maintenance.county,
                    area : maintenance.area, 
                    damageDate : maintenance.damagedate, 
                    reportedFrom : maintenance.damagereportfrom, 
                    reportedFromDetails : maintenance.damagedetails, 
                    status : maintenance.damagestatus, 
                    receiptDate : maintenance.receiptdate,  
                    receipttime : maintenance.receipttime, 
                    priority : maintenance.priority, 
                    responsibilityOf : maintenance.responsible, 
                    restorationWork : maintenance.restorationwork, 
                    restorationDate : maintenance.restorationdate, 
                    files : maintenance.files, 
                    notes : maintenance.notes, 
                    restorationStatus : maintenance.restorationstatus
                })

                return response.data;
            } catch (error) {
                console.error("API Error", error);
            }
        },

        GetSpecificMaintenance: async (maintenanceID) => {
            try {
                const response = await api.get(`Maintenance/${maintenanceID}`, {
                    NsApplication : "megara",
                })

                return response.data;
            } catch (error) {
                console.error("API Error", error.response?.data || error.message);
            }
        },

        FlowMaintenanceUpdate: async (maintenance) => {
        try {
            const response = await api.patch(`Maintenance/${maintenance.maintenanceid}`, {
                NsApplication : "megara",
                id : maintenance.flowmaintenanceid,
                maintenanceType : maintenance.typemaintenance, 
                deviceType : maintenance.devicetype, 
                deviceId : maintenance.deviceflowid, 
                county : maintenance.county,
                area : maintenance.area, 
                damageDate : maintenance.damagedate, 
                damagetime : maintenance.damagetime, 
                reportedFrom : maintenance.damagereportfrom, 
                reportedFromDetails : maintenance.damagedetails, 
                status : maintenance.damagestatus, 
                receiptDate : maintenance.receiptdate,  
                priority : maintenance.priority, 
                responsibilityOf : maintenance.responsible, 
                restorationWork : maintenance.restorationwork, 
                restorationDate : maintenance.restorationdate, 
                restorationtime : maintenance.restorationtime, 
                notes : maintenance.notes, 
                restorationStatus : maintenance.restorationstatus
            })

            return response.data;
            } catch (error) {
                console.error("API Error", error);
            }
        },

        FlowMaintenanceDelete: async (maintenance) => {
            try {
                const response = await api.delete(`Maintenance/${maintenance.maintenanceid}`, {
                    NsApplication : "megara",
                })

                return response.data;
            } catch (error) {
                console.error("API Error", error);
            }
        }
    }
}